<template>
    <div class="not-found-page">
        <div class="centered">
            <h1><img src="img/logo.jpg" /></h1>
            <p>Esta pagina no se encuentra en el sistema.</p>
            <p><a href="#/">Volver a inicio</a></p>
        </div>
    </div>
</template>

<script>
    export default {
        methods: {
            borrarcookies() {
                this.$store.dispatch("setJWT", "");
                this.$cookie.delete('jwt');
                this.$router.push("/inicio");
            }
        }
    }
</script>
<style lang="scss">
    .not-found-page {
        .full-page > .content,
        .centered {
            min-height: calc(100vh - 160px);
        }
        .not-found-icon {
            margin-right: 10px;
        }
        .centered {
            h1, i {
                font-size: 50px;
            }
            p {
                font-size: 20px;
            }
            display: flex;
            padding-bottom: 150px;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }
    }

</style>
